"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _core = require("@focaltec-suite/core");
var _commons = require("@focaltec-suite/commons");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var TenantLogo = (0, _material.styled)('img')(function (_ref) {
  var theme = _ref.theme;
  return {
    maxWidth: '200px',
    maxHeight: '64px'
  };
});
function TenantDetail() {
  var _a, _b, _c, _d;
  var context = (0, _react.useContext)(_core.AppContext);
  var access = (0, _react.useMemo)(function () {
    return context.access;
  }, [context]);
  var tenant = (0, _react.useMemo)(function () {
    return access === null || access === void 0 ? void 0 : access.tenant;
  }, [access]);
  var assistingTo = (0, _react.useMemo)(function () {
    return access === null || access === void 0 ? void 0 : access.assisting_to;
  }, [access]);
  if (!tenant) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
  }
  return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    sx: {
      mb: 2
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 10
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    sx: {
      mb: 2
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12,
    sx: {
      mt: 1
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    justifyContent: "center"
  }, tenant.metadata.logo_url ? /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12,
    sx: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement(TenantLogo, {
    src: tenant.metadata.logo_url
  })) : /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: "auto"
  }, /*#__PURE__*/_react["default"].createElement(_commons.TenantAvatar, {
    tenantName: tenant.name,
    size: 8
  })))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12,
    sx: {
      mt: 1
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Stack, {
    direction: "column",
    justifyContent: "center"
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body1",
    component: "h1",
    textAlign: "center",
    sx: function sx(theme) {
      return {
        maxHeight: theme.spacing(3),
        width: '100%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        wordWrap: 'break-word'
      };
    }
  }, tenant.name), assistingTo && /*#__PURE__*/_react["default"].createElement(_material.Stack, {
    direction: "row",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    spacing: 1
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "caption",
    color: "textSecondary"
  }, (0, _core.translate)(assistingTo.type === 'regular' ? 'assistants.assisting_mode' : 'assistants.platform_mode')), /*#__PURE__*/_react["default"].createElement(_material.Tooltip, {
    placement: "right",
    title: (0, _core.translate)(assistingTo.type === 'regular' ? 'assistants.assisting_tooltip' : 'assistants.platform_tooltip', {
      name: (_b = (_a = assistingTo.user) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '---',
      role: (_d = (_c = assistingTo.role) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : '---'
    })
  }, /*#__PURE__*/_react["default"].createElement(_commons.HelpIcon, {
    fontSize: "small"
  })))))), /*#__PURE__*/_react["default"].createElement(_material.Divider, null)));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(TenantDetail);